import { getRequest } from '../../httpClient';
import type { IListPublicCollectionSlugsV2Response } from './list-public-collection-slugs-v2-response';
import { listPublicCollectionSlugsV2ResponseSchema } from './list-public-collection-slugs-v2-response';

interface IListPublicCollectionSlugsV2Options {
  cursor?: string;
  limit?: number;
}

export async function listPublicCollectionSlugsV2Api(
  options?: IListPublicCollectionSlugsV2Options,
) {
  const params: Record<string, string | number> = {};
  if (options?.cursor) {
    params.cursor = options.cursor;
  }
  if (options?.limit) {
    params.limit = options.limit;
  }
  return getRequest<IListPublicCollectionSlugsV2Response>({
    path: '/collections/v2/slugs',
    options: Object.keys(params).length > 0 ? { params } : undefined,
    schema: listPublicCollectionSlugsV2ResponseSchema,
  });
}
